<template>

            <section :class="{'full-sized-style':isFullSized()}">
                <div v-if="!widget.iframe" class="col-sm-12 no-widget-padding" v-html="widget.html">
                </div>

                <iframe v-if="widget.iframe" id="contentIframe" style="background: white" @load="iframeLoaded()" :src="'data:text/html;charset=utf-8,'+widget.html" width="100%" height="100%" frameBorder="0" scrolling="no">
                </iframe>
            </section>


</template>

<script>
export default{
    props:['widget'],
    methods:{
        iframeLoaded:function () {
            var iframe = frames["contentIframe"];
            iframe.height = iframe.contentWindow.document.body.scrollHeight + "px";
        },
        isFullSized(){
            return screen.width>576 && this.widget.fullSized
        }
    }
}
</script>

<style>
.full-sized-style{
    position: relative;
    width: 100vw!important;
    left: calc(-50vw + 50%)!important;
}
body{
    overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// HtmlWidget.vue?05d3ff48